import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import type { BeneficiarySummary, Paginated } from '@foundation/shared';
import { api, buildQuery } from '../lib/api';
import { BENEFICIARY_STATUS_TH, CATEGORY_TH, fullName, maskNationalId } from '../lib/format';

export default function Search() {
  const navigate = useNavigate();
  const [q, setQ] = useState('');
  const [rows, setRows] = useState<BeneficiarySummary[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const ac = new AbortController();
    const t = setTimeout(() => {
      setError(null);
      api<Paginated<BeneficiarySummary>>(
        `/beneficiaries${buildQuery({ q, limit: 30 })}`,
        { signal: ac.signal },
      )
        .then((res) => setRows(res.data))
        .catch((e: unknown) => {
          if (ac.signal.aborted) return;
          setError(e instanceof Error ? e.message : 'ค้นหาไม่สำเร็จ');
          setRows([]);
        });
    }, q ? 300 : 0);

    return () => {
      clearTimeout(t);
      ac.abort();
    };
  }, [q]);

  return (
    <div className="screen">
      <div className="topbar">
        <button className="back" onClick={() => navigate(-1)}>
          ← กลับ
        </button>
        <h1>ค้นหา</h1>
      </div>

      <div className="field">
        <input
          type="search"
          inputMode="search"
          autoFocus
          placeholder="ชื่อ นามสกุล รหัส เบอร์โทร"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
      </div>

      {error && <div className="alert error">{error}</div>}

      {rows === null ? (
        <div className="center">กำลังค้นหา…</div>
      ) : rows.length === 0 ? (
        <div className="center">
          {q ? 'ไม่พบข้อมูลที่ค้นหา' : 'ยังไม่มีผู้รับความช่วยเหลือในความดูแลของคุณ'}
        </div>
      ) : (
        <>
          <p className="muted small">พบ {rows.length} รายการ</p>
          {rows.map((b) => (
            <Link key={b.id} className="list-item" to={`/beneficiary/${b.id}`}>
              <div className="row">
                <div style={{ minWidth: 0 }}>
                  <div className="list-title">{fullName(b)}</div>
                  <div className="list-sub">
                    <span className="mono">{b.benCode}</span>
                    {b.category && ` · ${CATEGORY_TH[b.category] ?? b.category}`}
                  </div>
                  <div className="list-sub mono">{maskNationalId(b.nationalIdLast4)}</div>
                </div>
                <span className={`badge ${b.status === 'active' ? 'green' : ''}`}>
                  {BENEFICIARY_STATUS_TH[b.status] ?? b.status}
                </span>
              </div>
            </Link>
          ))}
        </>
      )}
    </div>
  );
}
